import { FC, forwardRef } from 'react';
import { RadioButtonGroup } from '@fe-learner-common';
type CheckboxProps = {
  filterKey: string;
  label: string;
  items: { key: string; label: string }[];
  selected: string;
  onChange: (value: string) => void;
};

export const SingleChoice: FC<CheckboxProps> = forwardRef<
  HTMLDivElement,
  CheckboxProps
>(({ filterKey, onChange, selected, label, items }, ref) => {
  const ariaKey = `filter-group-${filterKey}`;

  return (
    <div ref={ref} role="group">
      <div className="flex items-center justify-between px-3 py-3.5">
        <h2 className="text-label-md leading-5 text-neutral-500" id={ariaKey}>
          {label}
        </h2>
      </div>

      <RadioButtonGroup
        selected={selected}
        onValueChange={onChange}
        size="md"
        items={items.map((x) => ({ ...x, disabled: selected === x.key }))}
        ariaLabel={label}
        id={filterKey}
      />
    </div>
  );
});

SingleChoice.displayName = 'SingleChoice';
